// extracted by mini-css-extract-plugin
export default {"wrap":"ScopeSwitcher_wrap__+QF73","btn":"ScopeSwitcher_btn__pTWxj","active":"ScopeSwitcher_active__Sl5+f","icon":"ScopeSwitcher_icon__OKhBJ"};